<template>
	<main id="page" class="getpaid" ref="page">
		<div class="mobile__head">
			<span class="mobile__head__back" @click="closeDrawer">
				<span class="mobile__head__back__icon">
					<svg viewBox="0 0 50 50">
						<use xlink:href="#icon--back" width="100%" height="100%"></use>
					</svg>
				</span>
				<span class="mobile__head__back__label">
					{{ $t('common.back') }}
				</span>
			</span>
		</div>
		<!-- <div class="getpaid__head">
			<div class="content">
				<div class="getpaid__head__title">
					{{ $t('common.titles.getpaid') }}
				</div>
			</div>
		</div> -->
		<template v-if="pageLoading">
			<Loading :isLoading="pageLoading" />
		</template>
		<template v-else>
			<div class="getpaid__content">
				<div class="smallcontent">
					<div class="getpaid__update">
						<span class="btn filled save" @click="saveIban" :class="{ 'disabled': (user.iban === '' && garagingPayments) }">
							Aggiorna Ricezione Pagamenti
						</span>
						<span v-if="success || error" class="getpaid__update__text" :class="[
							success ? 'success' : '',
							error ? 'error' : ''
						]">
								Metodo di ricezione pagamenti aggiornato con successo!
							</span>
					</div>
					<div class="getpaid__box">
						<div class="getpaid__switch">
							<div class="getpaid__switch__title">
								Incassa subito con Stripe
							</div>
							<div class="getpaid__switch__toggle">
								<label for="stripe" class="truefalse__toggle">
									<input type="checkbox" name="stripe" id="stripe" class="truefalse__toggle__input" @change="isGaragingPaying($event)" />
									<span class="truefalse__toggle__btn" :class="{ 'on': !garagingPayments }"></span>
								</label>
							</div>
							<div class="getpaid__switch__info">
								Crea o collega il tuo account Stripe a Garaging e ricevi i pagamenti direttamente sul tuo conto corrente dopo ogni prenotazione.<br />
								La soluzione più veloce, trasparente e autonoma per monetizzare il tuo parcheggio.
							</div>
							<div v-if="!garagingPayments" class="getpaid__switch__content">
								<template v-if="stripeConnected">
									<span class="getpaid__box__text" v-html="$t('getpaid.connected')"></span>
									<span class="getpaid__box__icon">
										<svg viewBox="0 0 50 50">
											<use xlink:href="#icon--check" width="100%" height="100%"></use>
										</svg>
									</span>
									<a href="https://connect.stripe.com/login" target="_blank" class="getpaid__box__btn btn filled">
										{{ $t('getpaid.btns.connected') }}
									</a>
								</template>
								<template v-else>
									<span class="getpaid__box__text" v-html="$t('getpaid.text')"></span>
									<template v-if="!showbtn">
										<span class="getpaid__box__loading">
											<Spinner />
										</span>
									</template>
									<template v-else>
										<a :href="url" target="_blank" class="getpaid__box__btn btn filled">
											{{ $t('getpaid.btns.not_connected') }}
										</a>
									</template>
								</template>
							</div>
						</div>
					</div>
					<div class="getpaid__box">
						<div class="getpaid__switch">
							<div class="getpaid__switch__title">
								Ricevi un bonifico da Garaging
							</div>
							<div class="getpaid__switch__toggle">
								<label for="iban" class="truefalse__toggle">
									<input type="checkbox" name="iban" id="iban" class="truefalse__toggle__input" @change="isGaragingPaying($event)" />
									<span class="truefalse__toggle__btn" :class="{ 'on': garagingPayments }"></span>
								</label>
							</div>
							<div class="getpaid__switch__info">
								Non hai un account Stripe o preferisci non gestirlo?
								Nessun problema: Garaging incassa per te e ti invia un bonifico ogni 15 giorni sul tuo conto corrente (<a href="https://garaging.it/termini-e-condizioni/" target="_blank" style="text-decoration: underline;">vedi termini e condizioni</a>).<br />
								Zero pensieri, nessuna attivazione richiesta: pensiamo a tutto noi.
							</div>
							<div v-if="garagingPayments" class="getpaid__switch__content">
								<form id="insertIban" name="insertIban" class="form">
									<label for="iban">
										Inserisci il tuo IBAN
									</label>
									<input type="text" class="form__input" name="iban" v-model="user.iban" placeholder="Inserisci il tuo iban" />
									<small class="form__info">* Vedi termini e condizioni d'uso</small>
								</form>
							</div>
						</div>
					</div>
					<div class="getpaid__update">
						<span class="btn filled save" @click="saveIban" :class="{ 'disabled': (user.iban === '' && garagingPayments) }">
							Aggiorna Ricezione Pagamenti
						</span>
						<span v-if="success || error" class="getpaid__update__text" :class="[
							success ? 'success' : '',
							error ? 'error' : ''
						]">
								Metodo di ricezione pagamenti aggiornato con successo!
							</span>
					</div>
				</div>
			</div>
		</template>
	</main>
</template>
<script>
import { EventBus } from '@/events_bus.js';
import { gsap } from 'gsap';
import { CustomEase } from 'gsap/all';
gsap.registerPlugin(CustomEase);

import Loading from '@/views/components/common/Loading';
import Spinner from '@/views/components/common/Spinner';

export default {
	name: 'GetPaid',
	data() {
		return {
			nogetpaid: true,
			getpaid: null,
			showbtn: false,
			stripeConnected: false,
			pageLoading: true,
			garagingPayments: false,
			user: null,
			success: false,
			error: false,
		}
	},
	components: {
		Loading,
		Spinner
	},
	methods: {
		isGaragingPaying() {
			this.garagingPayments = !this.garagingPayments;
		},
		saveIban() {
			this.isLoading = true;
			this.user.monthly_payment = this.garagingPayments;
			this.user.iban = this.user.iban.trim();
			this.$service.user.me.update(this.user).then(res => {
				console.log('UPDATE --->>>', res);
				this.success = true;
				this.error = false;
				this.isLoading = false;
			}).catch(err => {
				console.error(err);
				this.error = true;
				this.success = false;
				this.isLoading = false;
			});
		},
		closeDrawer() {
			this.$router.go(-1);
		},
		connectStripe() {
		},
		init() {
			this.$service.user.me.get().then(res => {
				this.pageLoading = false;
				console.log(res)
				if(res) {
					this.user = res;
					this.garagingPayments = res.monthly_payment || false;
					this.user.iban = res.iban || '';
					if(res.stripe_verified_at) {
						this.stripeConnected = true;
					} else {
						if(!this.garagingPayments) {
							this.$service.stripe.connect().then(res => {
								this.showbtn = true;
								this.url = res.url;
							})
						}
					}
				}
			})
		}
	},
	mounted() {
		this.loading = true;
		this.init();
	}
}
</script>
<style lang="scss">

.getpaid {
	padding-top: var(--head);
	overflow: auto;
	&__update {
		display: flex;
		justify-content: flex-end;
		flex-wrap: wrap;
		width: 100%;
		margin-bottom: var(--gutter);
		.save {
			background: $color-blue;
			color: $color-white;
			margin-top: var(--gutter);
			@media (min-width: 1200px) {
				width: max-content;
				min-width: 300px;
			}
		}
		&__text {
			display: block;
			width: 100%;
			margin-top: var(--gutter);
			text-align: right;
			&.success {
				color: $color-success;
				font-variation-settings: 'wght' 600;
			}
		}
	}
	.mobile__head {
		@extend %flexCenterBetween;
		@include size(100%, var(--head));
		padding: 0 var(--gutter);
		position: relative;
		&__back {
			@extend %flexCenterStart;
			width: calc(100% - var(--btn));
			cursor: pointer;
			&__icon {
				@extend %flexCenterCenter;
				@include size(var(--smallicon),var(--smallicon));
				svg {
					display: block;
					@include size(75%,75%);
					fill: $color-black;
				}
			}
			&__label {
				@extend %text-15;
				display: block;
				width: max-content;
				font-variation-settings: 'wght' 600;
				padding-left: var(--minigutter);
			}
		}
	}
	&__box {
		@extend %panel;
		display: block;
		width: 100%;
		padding: var(--gutter);
		margin-bottom: var(--gutter);
		&__title,
		&__text {
			display: block;
			width: 100%;
			margin-bottom: var(--gutter);
			text-align: left;
			padding: var(--gutter);
			background: rgba($color-black, 0.04);
			border-radius: var(--radius);
		}
		&__icon {
			@extend %flexCenterCenter;
			@include size(var(--icon),var(--icon));
			border: 3px solid $color-success;
			border-radius: 100%;
			margin: 0 auto;
			svg {
				display: block;
				@include size(60%,60%);
				fill: $color-success;
			}
		}
		&__btn {
			padding: 0 var(--gutter);
			background: $color-blue;
			width: max-content;
			color: $color-white;
			margin: var(--gutter) auto;
		}
		&__loading {
			@extend %flexCenterCenter;
			@include size(var(--supergutter),var(--supergutter));
			margin: 0 auto;
			.spinner {
				@include size(80%,80%);
			}
		}
	}
	&__empty {
		@extend %flexCenterCenter;
		flex-direction: column;
		@include size(330px,100%);
		margin: 0 auto;
		margin-top: var(--supergutter);
	}
	&__content {
		display: block;
		width: 100%;
		margin: var(--supergutter) 0;
		@media (min-width: $from-large) {
			.small-panel {
				height: var(--smallpanelh);
			}
		}
	}
	&__switch {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		width: 100%;
		margin-bottom: calc(var(--supergutter) * 1.5);
		&:last-of-type {
			margin-bottom: 0;
		}
		&__title {
			display: block;
			width: 80%;
			font-variation-settings: 'wght' 700;
			color: $color-caribbean;
		}
		&__info {
			display: block;
			width: 100%;
			font-size: 0.9rem;
			margin-top: var(--minigutter);
		}
		&__content {
			display: block;
			width: 100%;
			margin-top: var(--gutter);
			.form__info {
				display: block;
				font-size: 0.8rem;
				color: $color-davy;
				margin-top: var(--minigutter);
			}
		}
		.truefalse {
			&__toggle {
				@extend %flexCenterBetween;
				width: 100%;
				max-width: 300px;
				cursor: pointer;
				&__input {
					display: none;
				}
				&__label {
					@extend %text-15;
					display: block;
					font-family: $font-manrope;
					padding-right: var(--thirdgutter);
				}
				&__btn {
					display: block;
					@include size(48px,22px);
					border-radius: var(--minigutter);
					border: 1px solid $color-davy;
					position: relative;
					&:before {
						content: '';
						position: absolute;
						top: 50%;
						left: 2px;
						display: block;
						background: $color-blue;
						@include size(16px,16px);
						border-radius: 100%;
						transform: translateY(-50%);
						transition: 180ms linear;
						filter: grayscale(1);
					}
					&.on {
						&:before {
							left: calc(100% - 18px);
							filter: grayscale(0);
						}
					}
				}
			}
		}
	}
	@media (min-width: $from-large) {
		.mobile__head {
			display: none;
		}
		&__box {
			padding: var(--supergutter) var(--supergutter) var(--gutter);
		}
	}
	@media (max-width: $to-large) {
		position: fixed;
		top: 0;
		left: 0;
		display: block;
		background: $color-white !important;
		padding-top: 0;
		z-index: 100000;
		&__head {
			display: none;
		}
		&__box {
			border-radius: 0;
			box-shadow: none;
			padding: 0;
		}
		&__content {
			margin-top: 0;
		}
	}
}
</style>
